import { render } from "./NormvaluesExport.vue?vue&type=template&id=b34c23f6&scoped=true"
import script from "./NormvaluesExport.vue?vue&type=script&lang=js"
export * from "./NormvaluesExport.vue?vue&type=script&lang=js"

import "./NormvaluesExport.vue?vue&type=style&index=0&id=b34c23f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b34c23f6"]])

export default __exports__